export default __webpack_public_path__ + "static/media/DM.46e49efb.svg";